// The 'load' event fires when the entire page and its resources have loaded
window.addEventListener('load', function () {
  // Get the parent container where you want to add your video
  var parentContainer = document.querySelector('.boost-pfs-filter-left-col');

  // Create the outer video-container div
  var videoContainer = document.createElement('div');
  videoContainer.className = 'video-container';

  // Create the inner shopify-video div
  var shopifyVideo = document.createElement('div');
  shopifyVideo.className = 'shopify-video';

  // Create the video element
  var videoElement = document.createElement('video');
  videoElement.setAttribute('controls', '');
  videoElement.className = 'shopify-video';

  var videoSource = document.createElement('source');
  videoSource.src =
    'https://cdn.shopify.com/videos/c/o/v/e8577941e0d54ae5ab1e004fa9125272.mp4';
  videoSource.type = 'video/mp4';

  videoElement.appendChild(videoSource);
  shopifyVideo.appendChild(videoElement);
  videoContainer.appendChild(shopifyVideo);
  parentContainer.appendChild(videoContainer);

  // Add click event listener to shopifyVideo
  shopifyVideo.addEventListener('click', function () {
    videoElement.play();
  });
});
